import React from 'react';
import { css } from '@emotion/react';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import SiteSearchBar from '../../site-search/site-search-input';
import { colors } from '../../primitives/colors';
import Link from '../../primitives/link';
import { breakpoints } from '../../primitives/tokens';
import Typography from '../../primitives/typography';

const styles = {
    link: css({
        textDecoration: 'underline',
        transition: 'color 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        ':hover': {
            color: colors.primaryOrangeHover,
        },
    }),
    quickLinksSection: css({
        position: 'relative',
        zIndex: 20,
        width: '100%',
        fontSize: '18px',
        lineHeight: '28px',
        paddingBottom: '16px',
        paddingTop: '16px',
        [breakpoints.mb]: {
            paddingBottom: '0',
            paddingTop: '24px',
        },
    }),
    heading: css({
        color: colors.shadesBlack,
        marginBottom: '20px',
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 600,
    }),
    linksWrap: css({
        fontSize: '21px',
        color: colors.primaryOrange,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: '28px',
        '>:not([hidden])~:not([hidden])': {
            marginTop: '20px',
        },
        [breakpoints.mb]: {
            paddingLeft: '0',
            paddingRight: '0',
        },

    }),
    searchbarGroup: {
        borderRadius: '5px',
        paddingLeft: '32px',
        paddingRight: '32px',
        paddingTop: '20px',
        paddingBottom: '32px',
        backgroundColor: colors.shadesBlack,
    },
    searchbarTitle: {
        marginBottom: '8px',
        color: colors.shadesWhite,
        letterSpacing: '1.2px',
    },
};

const QuickLinks: React.FC<Queries.ServicesDetailDataFragment['quicklinks']> = (data) => {
    const { isMicrosite, ...microsite } = useMicrosite();
    if (!data) return null;

    const { heading, links } = data;

    if (!links || links.length === 0) {
        return null;
    }

    return (
        <div css={styles.quickLinksSection}>
            <Typography
                as="h2"
                fontSize={{
                    dt: '2xl',
                    mb: 'xl',
                }}
                css={{
                    marginBottom: '16px',
                }}
                fontWeight="medium"
            >
                {heading}
            </Typography>
            <div css={styles.linksWrap}>
                {links && links.length > 0 && links.map((link) => {
                    if (!link?.href) {
                        return null;
                    }
                    if (isMicrosite && microsite?.bannedInternalLinks?.find(x => x === link.href)) {
                        return null;
                    }
                    return (
                        <Link css={styles.link} key={link.title} to={link.href}>
                            {link.title}
                        </Link>
                    );
                })}
            </div>
            {!isMicrosite && (
                <div css={styles.searchbarGroup}>
                    <p css={styles.searchbarTitle}>Have another question?</p>
                    <div>
                        <SiteSearchBar />
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuickLinks;
